import { useEffect, useState } from 'react';
import { useApi } from '../providers/api-provider';
import Config from './config';
import { ADMIN_TASKS_CHANGED, AdminTaskSummary } from './admin-tasks';

export function useAdminTaskSummary(enabled: boolean, identity: string | undefined, pathname: string) {
    const api = useApi();
    const [snapshot, setSnapshot] = useState<{ identity: string; summary: AdminTaskSummary } | null>(null);
    useEffect(() => {
        if (!enabled || !identity || !api) return;
        let controller: AbortController | undefined;
        const refresh = () => {
            controller?.abort();
            const request = new AbortController(); controller = request;
            api.getAdminTaskSummary(Config.env === 'local' ? 'sandbox' : 'production', request.signal)
                .then(result => { if (!request.signal.aborted) setSnapshot({ identity, summary: result }); })
                .catch(() => { if (!request.signal.aborted) setSnapshot(null); });
        };
        refresh();
        window.addEventListener('focus', refresh);
        window.addEventListener(ADMIN_TASKS_CHANGED, refresh);
        return () => {
            controller?.abort();
            window.removeEventListener('focus', refresh);
            window.removeEventListener(ADMIN_TASKS_CHANGED, refresh);
        };
    }, [api, enabled, identity, pathname]);
    return enabled && snapshot && snapshot.identity === identity ? snapshot.summary : null;
}

export function useAdminTaskCount(enabled: boolean, identity: string | undefined, pathname: string) {
    return useAdminTaskSummary(enabled, identity, pathname)?.total ?? null;
}
